import { useTranslate } from 'ra-core';
import { MoonstarCreate } from '../Moonstar/MoonstarCreate';
import { MoonstarCreateForm } from '../Moonstar/MoonstarCreateForm';
import { SeverityAlert } from '../Moonstar/SeverityAlert';
import { SimpleStack } from '../Moonstar/SimpleStack';
import { BadgeInputs } from './BadgeInputs';

export const BadgesCreate = () => {
  const translate = useTranslate();

  return (
    <MoonstarCreate redirect="list">
      <MoonstarCreateForm>
        <SeverityAlert
          severity="warning"
          title={translate('moonstar.badges.noDeletion.title')}
        >
          {translate('moonstar.badges.noDeletion.description')}
        </SeverityAlert>
        <SimpleStack>
          <BadgeInputs />
        </SimpleStack>
      </MoonstarCreateForm>
    </MoonstarCreate>
  );
};
